// extracted by mini-css-extract-plugin
export default {"pageRoot":"StartYourProjectPage_pageRoot__Tuhqf"};